import { Controller } from "@hotwired/stimulus"

/**
 * specialist-list-filter
 *
 * Two-button filter ("Tu organización" / "Gobierto") above a specialist list.
 * Toggles items based on their `data-source` attribute. Clicking the active
 * button again unselects the filter.
 *
 * Targets:
 * - button: filter buttons with a `data-source` value
 * - item: specialist list items with a matching `data-source` value
 *
 * Values:
 * - active: currently selected source, or blank when all items are visible
 *
 * Example:
 * <div data-controller="specialist-list-filter">
 *   <button data-specialist-list-filter-target="button"
 *           data-source="own"
 *           data-action="click->specialist-list-filter#toggle"></button>
 *   <li data-specialist-list-filter-target="item" data-source="own"></li>
 * </div>
 */
export default class extends Controller {
  static targets = ["button", "item"]
  static values = { active: { type: String, default: "" } }

  toggle(event) {
    const source = event.currentTarget.dataset.source
    this.activeValue = this.activeValue === source ? "" : source
  }

  activeValueChanged() {
    this.buttonTargets.forEach(btn => {
      const isActive = btn.dataset.source === this.activeValue
      btn.classList.toggle("specialist-list-filter-btn--active", isActive)
      btn.setAttribute("aria-pressed", isActive ? "true" : "false")
    })

    this.itemTargets.forEach(item => {
      const matches = !this.activeValue || item.dataset.source === this.activeValue
      item.classList.toggle("hidden", !matches)
    })
  }
}
